import { apiGet, useApiData } from './apiClient';

export const FALLBACK_SETTLEMENT_CATEGORIES = [
  { id: 'advertisement', name: 'Reklam', kind: 'both', code: 'advertisement', isActive: true, order: 1 },
  { id: 'subscription', name: 'Abonelik', kind: 'both', code: 'subscription', isActive: true, order: 2 },
  { id: 'commission_adjust', name: 'Komisyon Düzeltmesi', kind: 'both', code: 'commission_adjust', isActive: true, order: 3 },
  { id: 'sponsor', name: 'Sponsorluk', kind: 'income', code: 'sponsor', isActive: true, order: 4 },
  { id: 'other', name: 'Diğer', kind: 'both', code: 'other', isActive: true, order: 99 },
];

/**
 * Sale report gelir/gider select options.
 * @param {'income'|'expense'} [entryType]
 */
export const getSettlementCategories = async (entryType) => {
  let rows = FALLBACK_SETTLEMENT_CATEGORIES;

  if (useApiData) {
    try {
      const res = await apiGet('settlementCategories?perPage=200&sort=order&order=asc');
      const data = res?.data ?? (Array.isArray(res) ? res : []);
      if (Array.isArray(data) && data.length > 0) {
        rows = data;
      }
    } catch {
      // fallback
    }
  }

  return rows
    .filter((row) => row?.isActive !== false)
    .filter((row) => {
      if (!entryType) return true;
      const kind = row.kind || 'both';
      return kind === 'both' || kind === entryType;
    })
    .sort((a, b) => Number(a.order || 0) - Number(b.order || 0));
};

export default { getSettlementCategories, FALLBACK_SETTLEMENT_CATEGORIES };
